import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import Stamp from "../../models/stamp";

interface StampDeleteModalProps {
  show: boolean;
  stamp?: Stamp;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const StampDeleteModal: React.FC<StampDeleteModalProps> = ({
  show,
  stamp,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = stamp
    ? `Está seguro de que quiere eliminar el timbrado Nº ${stamp.identifier}`
    : "";

  const onDeleteClick = async () => {
    if (stamp !== undefined) {
      setSubmitting(true);
      const stampStatus = await deleteItem(`/stamps/${stamp.id}/`, stamp);

      if (stampStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (stampStatus.detail !== undefined) {
          message = stampStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default StampDeleteModal;
